import { render, staticRenderFns } from "./WordDrumPreview.vue?vue&type=template&id=1eba81a0&lang=pug&"
import script from "./WordDrumPreview.vue?vue&type=script&lang=js&"
export * from "./WordDrumPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports